import { useDispatch } from 'react-redux';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import {
  resetData,
  resetErrors
} from 'state/meterpoint-validation/meterpoint-validation-slice';

type MeterpointCardProps = {
  MPAN: string | number;
  MPRN: string | number;
  hasElecAddress: boolean;
  hasGasAddress: boolean;
};

export const MeterpointCard = ({
  MPAN,
  MPRN,
  hasElecAddress,
  hasGasAddress
}: MeterpointCardProps) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(resetData());
    dispatch(resetErrors());
  };

  if (!hasElecAddress && !hasGasAddress) {
    return null;
  }

  return (
    <NsCard>
      {hasElecAddress && (
        <>
          <p>
            <strong>MPAN for electricity</strong>
          </p>
          <p>{MPAN}</p>
        </>
      )}
      {hasGasAddress && (
        <>
          <p>
            <strong>MPRN for gas</strong> <br />
          </p>
          <p>{MPRN}</p>
        </>
      )}
      <NsSecondaryCta onClick={handleClick}>Edit</NsSecondaryCta>
    </NsCard>
  );
};
